var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3128_6471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5716 28.0713L31.4287 28.0713L31.4287 11.7856L12.5716 11.7856L12.5716 28.0713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2113 8.07129H26.7884C30.9484 8.07129 33.4284 10.5513 33.417 14.7113V24.2884C33.417 28.4484 30.937 30.9284 26.777 30.9284H17.2113C13.0513 30.9284 10.5713 28.4484 10.5713 24.277V14.7113C10.5713 10.5513 13.0513 8.07129 17.2113 8.07129ZM26.2425 24.9546L21.9998 20.712L17.7572 24.9546C17.4259 25.2859 16.8763 25.2859 16.545 24.9546C16.2137 24.6233 16.2137 24.0738 16.545 23.7424L20.7876 19.4998L16.545 15.2571C16.2137 14.9258 16.2137 14.3763 16.545 14.045C16.8763 13.7136 17.4259 13.7136 17.7572 14.045L21.9998 18.2876L26.2425 14.045C26.5738 13.7136 27.1233 13.7136 27.4546 14.045C27.786 14.3763 27.786 14.9258 27.4546 15.2571L23.212 19.4998L27.4546 23.7424C27.786 24.0738 27.786 24.6233 27.4546 24.9546C27.1233 25.2859 26.5738 25.2859 26.2425 24.9546Z",
    fill: "#E53935"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3128_6471",
    x: 0.571289,
    y: 0.0712891,
    width: 42.8457,
    height: 42.8569,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3128_6471"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3128_6471",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseImg);
export default __webpack_public_path__ + "static/media/CloseImg.91ecea6522e95af93dde7c4b420d57d0.svg";
export { ForwardRef as ReactComponent };